import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { groupedCategoryAccountsByAccountFilterSelector } from "./groupedCategoryAccountsByAccountFilterSelector";

export const accountExcludedFiltersSelector = createDraftSafeSelector(
  [groupedCategoryAccountsByAccountFilterSelector],
  (data) => {
    return data?.excludedAccounts;
  },
);
